<template>
  <div class="activities-index">
    <div class="row">
      <div class="col-12 d-none d-sm-block" style="margin-top: 5px">
        <a v-for="child in children" :key="child.id" :href="'#child-' + child.id" class="text-center" style="display: inline-block; margin-right: 10px; text-decoration: none;">
          <child-thumbnail :key="child.id" :child="child" :height="'75px'"></child-thumbnail>
          <p style="font-size: 12px">
            {{ child.first_name }}
          </p>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12" style="">
        <div v-if="children.length > 0">
          <div v-for="child in children" :key="child.id" style="background: white; height: 100%; padding: 15px; padding-bottom: 8px; margin-bottom: 20px;">
            <a :id="'child-' + child.id"></a>
            <div class="row">
              <div class="col-sm-2 col-12 text-center">
                <div class="row">
                  <div class="col-sm-12 col-6">
                    <child-thumbnail :key="child.id" :child="child"></child-thumbnail>
                  </div>
                  <div class="col-sm-12 col-6">
                    <router-link :to="'/children/' + child.id + '/activities'">
                      <h4 style="margin: 0; margin-top: 5px">
                        {{ child.first_name }}
                      </h4>
                      <p style="margin: 5px; margin-top: 0">
                        {{ child.last_name_suffix }} {{ child.last_name }}
                      </p>
                    </router-link>
                    <router-link :to="'/children/' + child.id">
                      <span v-on:click="selectChild(child)">
                        <icon class="pe-1" name="info"></icon>
                      </span>
                    </router-link>
                    <span v-on:click="openModalWithChild(child)">
                      <icon name="plus-circle"></icon>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-10 col-12">
                <span v-if="getActivitiesByIdChild(child.id).length > 0">
                  <div
                      v-for="(activity, index) in getActivitiesByIdChild(child.id)"
                      :key="activity.id"
                  >
                    <activity-list-item
                        v-if="index === (getActivitiesByIdChild(child.id).length - 1)"
                        :activity="activity"
                        :divider="false"
                        :showEdit="true"
                        @onEdit="editActivity($event)"
                        :showDelete="true"
                        @onDelete="deleteActivity($event)"
                    />
                    <activity-list-item
                        v-else
                        :activity="activity"
                        :divider="true"
                        :showEdit="true"
                        @onEdit="editActivity($event)"
                        :showDelete="true"
                        @onDelete="deleteActivity($event)"
                    />
                  </div>
                </span>
                <p v-else>Geen activiteiten vandaag</p>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="text-center">Geen kinderen</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityListItem from '@/components/Activity-List-Item'
import ChildThumbnail from '@/components/Child-Thumbnail'
import Icon from '@/components/Icon'
export default {
  name: 'activities-index',
  components: {
    ActivityListItem,
    ChildThumbnail,
    Icon
  },
  props: {
    showPresentChildrenOnly: {
      default: true,
      type: Boolean
    },
    date: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      childIdsWithPlanningOnSelectedDate: []
    }
  },
  computed: {
    selectedGroupsQueryString () {
      return this.$store.getters.selectedGroupsQueryString
    },
    children () {
      var children = []
      children = this.getChildren()
      var app = this
      if (this.showPresentChildrenOnly === true) {
        children = this.$lodash().filter(children, function (child) {
          return app.getChildIsPresent(child)
        })
      }
      children = this.$lodash().filter(children, function (child) {
        return app.getChildHasPlanningOnSelectedDate(child.id)
      })
      return children
    },
    activities () {
      var rawActivities = this.$store.getters.groupActivities
      var activitiesPerChild = {}
      if (rawActivities) {
        for (var i = 0; i < rawActivities.length; i++) {
          var activityItem = rawActivities[i]
          if (!Object.prototype.hasOwnProperty.call(activitiesPerChild, activityItem.child_id)) {
            activitiesPerChild[activityItem.child_id] = {
              id_child: activityItem.child_id,
              activities: []
            }
          }
          activitiesPerChild[activityItem.child_id].activities.push(activityItem)
        }
      }
      return Object.values(activitiesPerChild)
    },
  },
  watch: {
    date (newDate) {
      this.loadChildIdsWithPlanningOnSelectedDate()
      this.$store.dispatch('getGroupActivities', newDate)
    }
  },
  created () {
    this.loadChildIdsWithPlanningOnSelectedDate()
    this.$store.dispatch('getChildren')
    this.$store.dispatch('getChildrenPresence')
    this.$store.dispatch('getGroupActivityTypes')
    this.$store.dispatch('getGroupActivities', this.date)
  },
  methods: {
    getChildHasPlanningOnSelectedDate (idChild) {
      for (var i = 0; i < this.childIdsWithPlanningOnSelectedDate.length; i++) {
        if (idChild === this.childIdsWithPlanningOnSelectedDate[i].child_id) {
          return true;
        }
      }
      return false;
    },
    loadChildIdsWithPlanningOnSelectedDate () {
      this.$request.get('/events/has-planning-on-date?id_group=' + this.selectedGroupsQueryString + '&date=' + this.date)
      .then((response) => {
        if (response.data) {
          this.childIdsWithPlanningOnSelectedDate = response.data
        } else {
          this.childIdsWithPlanningOnSelectedDate = []
        }
      })
    },
    getActivitiesByIdChild (idChild) {
      if (this.activities) {
        for (var i = 0; i < this.activities.length; i++) {
          if (parseInt(this.activities[i].id_child) === parseInt(idChild)) {
            return this.activities[i].activities;
          }
        }
      }
      return [];
    },
    sortActivities (activities) {
      return activities
    },
    selectChild (child) {
      if (child.id_child) {
        child.id = child.id_child
      }
      if (child.id) {
        child.id_child = child.id
      }
      this.$store.commit('SET_SELECTED_CHILD', child)
    },
    openModalWithChild (child) {
      this.$emit('openModalWithChild', child)
    },
    deleteActivity (activity) {
      if (confirm('Weet je zeker dat je deze activiteit wilt verwijderen?') !== true) {
        return
      }
      this.$request.delete('/activities/' + activity.id)
      .then((
      ) => {
        this.$store.dispatch('getGroupActivities')
        this.appendChildrenById([activity.child_id])
      })
    },
    editActivity (activity) {
      this.$emit('openModalWithActivity', activity)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a {
    color: #666;
  }
</style>
